<template>
    <div>
        <section class="mx-8 px-8 py-6 mb-[10px] bg-white rounded-md flex justify-between items-start">
            <h2 class="text-3xl">Тарифы</h2>
        </section>
        <section class="mx-8">
            <div class="grid grid-cols-3 gap-[10px]">
                <PricingCard :isActive="companyData.plan.name === 'free'" :isOneOff="companyData.plan.is_one_off" :currentAmountOfShops="companyData.plan.amount_of_shops" description="Подходит для новых пользователей, которые хотят протестировать сервис перед покупкой" name="free" :features='["Одна касса", "До 10 товарных операций в день", "Неограниченное количество сотрудников", "Неограниченное количество товаров", "Неограниченное количество клиентов"]'/>
                <PricingCard :isActive="companyData.plan.name === 'monthly'" :isOneOff="companyData.plan.is_one_off" :currentAmountOfShops="companyData.plan.amount_of_shops" description="Для тех, кто хочет гибкое управление подпиской на ежемесячной основе" name="monthly" :pricePerMonth="799" :priceByAdditionalShopPerMonth="399" :features='["Выбранное количество касс", "Неограниченное количество товарных операций в день", "Неограниченное количество сотрудников", "Неограниченное количество товаров", "Неограниченное количество клиентов"]'/>
                <PricingCard :isActive="companyData.plan.name === 'annual'" :isOneOff="companyData.plan.is_one_off" :currentAmountOfShops="companyData.plan.amount_of_shops" description="Для тех, кто хочет пользоваться больше, а платить меньше" name="annual" :pricePerMonth="599" :pricePerYear="7188" :priceByAdditionalShopPerMonth="299" :priceByAdditionalShopPerYear="3588" :features='["Выбранное количество касс", "Неограниченное количество товарных операций в день", "Неограниченное количество сотрудников", "Неограниченное количество товаров", "Неограниченное количество клиентов"]'/>
            </div>
        </section>
    </div>
</template>

<script>
    import { mapState } from 'vuex';

    import PricingCard from './PricingCard.vue';

    export default {
        name: "PricingList",
        components: {
            PricingCard
        },
        computed: {
            ...mapState(["companyData"])
        },
        data() {
            return {

            }
        }
    }
</script>